module.exports = __webpack_public_path__ + "img/product-6-report.af127d3d.png";